export default "__VITE_ASSET__B6bEz9zM__"